import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=628d61b8&scoped=true&"
import script from "./EvaluationList.vue?vue&type=script&lang=js&"
export * from "./EvaluationList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationList.vue?vue&type=style&index=0&id=628d61b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d61b8",
  null
  
)

export default component.exports